import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck, HeartPulse, GraduationCap, Users, Timer, ClipboardCheck, Home, Sparkles } from "lucide-react";

export function WhyChooseUs() {
    const { t } = useTranslation();
    const REASONS = [
        { icon: ClipboardCheck, title: t("whyChoose.r1Title"), desc: t("whyChoose.r1Desc") },
        { icon: HeartPulse, title: t("whyChoose.r2Title"), desc: t("whyChoose.r2Desc") },
        { icon: Users, title: t("whyChoose.r3Title"), desc: t("whyChoose.r3Desc") },
        { icon: Timer, title: t("whyChoose.r4Title"), desc: t("whyChoose.r4Desc") },
        { icon: Sparkles, title: t("whyChoose.r5Title"), desc: t("whyChoose.r5Desc") },
        { icon: GraduationCap, title: t("whyChoose.r6Title"), desc: t("whyChoose.r6Desc") },
        { icon: ShieldCheck, title: t("whyChoose.r7Title"), desc: t("whyChoose.r7Desc") },
        { icon: Home, title: t("whyChoose.r8Title"), desc: t("whyChoose.r8Desc") },
    ];
    return (
        <section data-testid="why-choose-us" className="container-page section-y">
            <div className="max-w-3xl">
                <span className="chip-teal">{t("whyChoose.chip")}</span>
                <h2 className="mt-3 font-display text-3xl sm:text-4xl font-semibold text-[color:var(--brand-navy)]">
                    {t("whyChoose.title")}
                </h2>
                <p className="mt-3 text-[color:var(--text-muted)] leading-relaxed">
                    {t("whyChoose.intro")}
                </p>
            </div>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {REASONS.map((r) => (
                    <div key={r.title} className="card-soft p-6">
                        <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[color:var(--brand-teal-soft)] text-[color:var(--brand-teal-2)]">
                            <r.icon className="h-5 w-5" />
                        </div>
                        <h3 className="mt-4 font-display text-base font-semibold text-[color:var(--brand-navy)]">
                            {r.title}
                        </h3>
                        <p className="mt-2 text-sm text-[color:var(--text-muted)] leading-relaxed">
                            {r.desc}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
